export const getCategoryHeaderId = (idx) => `app-category-${idx}`;

export const getOpeningHoursSchema = (data) => {
  const openingOptions = [];
  Object.entries(data)?.map((day) => {
    openingOptions.push({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [day[0]],
      opens: day[1][0]?.start,
      closes: day[1][0]?.end,
    });
  });
  return openingOptions;
};

const getMenuItemSchema = (items) => {
  const itemsSchema = [];
  items?.forEach((item) => {
    itemsSchema.push({
      '@type': 'MenuItem',
      name: item.name,
      description: item.description,
      offers: {
        '@type': 'Offer',
        price: item.value,
        priceCurrency: 'USD',
      },
    });
  });
  return itemsSchema;
};
const getMenuCategorySchema = (categories) => {
  const categoriesSchema = [];
  categories?.forEach((category) => {
    categoriesSchema.push({
      '@type': 'MenuSection',
      name: category.name,
      description: category.description,
      hasMenuItem: getMenuItemSchema(category.items || {}),
    });
  });
  return categoriesSchema;
};
export const getMenusSchema = (menus) => {
  const menusSchema = [];
  menus?.forEach((menu) => {
    menusSchema.push({
      '@type': 'MenuSection',
      name: menu.name,
      description: menu.description,
      hasMenuSection: getMenuCategorySchema(menu.categories || {}),
    });
  });
  return menusSchema;
};

export const getDeliveryMethodSchema = (merchant) => {
  const methodSchema = [];
  if (merchant?.has_delivery) methodSchema.push('http://purl.org/goodrelations/v1#DeliveryModeOwnFleet');
  if (merchant?.has_pickup) methodSchema.push('http://purl.org/goodrelations/v1#DeliveryModePickUp');
  return methodSchema;
};
